import InfiniteGrid, { GridLayout } from "@egjs/infinitegrid"
import { debounce } from 'lodash'

const getUrl = (element) => element.getAttribute('data-url')

const getPage = (element) => Number(element.getAttribute('data-page'))

const setPage = (page, element) => element.setAttribute('data-page', page)

const getHasMore = (element) => element.getAttribute('data-has_more')

const setHasMore = (hasMore, element) => element.setAttribute('data-has_more', hasMore)

const getNextItems = async (baseUrl, nextPage, element) => {
  const response = await fetch(`${baseUrl}.json?page=${nextPage}`)
  const data = await response.json()
  setPage(data['page'], element)
  setHasMore(data['has_more'], element)
  return data['items']
}

const getNextDebouncedItems = debounce((ig, element) => {
  const baseUrl = getUrl(element)
  const currentPage = getPage(element)
  const nextPage = currentPage + 1
  getNextItems(baseUrl, nextPage, element).then(items => {
    ig.append(items)
    ig.layout()
  })
  }, 200, {leading: true, trailing: false}
)

const initializeInfiniteGrid = (element) => {
  const ig = new InfiniteGrid(element, {
      horizontal: false,
      isConstantSize: true
   })
  ig.setLayout(GridLayout, {
    align: 'center',
    margin: 20
  })
  ig.layout()
  ig.on('append', (event) => {
    if (getHasMore(element) === 'false') return

    getNextDebouncedItems(ig, element)
  })
  window.addEventListener('turbolinks:before-visit', () => {
    ig.destroy()
  })
}

export { initializeInfiniteGrid }
